import { render, staticRenderFns } from "./EstruturaPermissao.vue?vue&type=template&id=5a517c6c&"
import script from "./EstruturaPermissao.vue?vue&type=script&lang=js&"
export * from "./EstruturaPermissao.vue?vue&type=script&lang=js&"
import style0 from "./estrutura_permissao.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports